export const EVENT_BUS_NAME_LIST = {
  SET_DATA_SOURCE_STATUS: 'SET_DATA_SOURCE_STATUS',
  SOCKET_CONNECTION_CLOSE: 'SOCKET_CONNECTION_CLOSE',
  SOCKET_CONNECTION_OPEN: 'SOCKET_CONNECTION_OPEN',
  WS_RES_ASYNC_EVENT: 'WS_RES_ASYNC_EVENT'
};
